import { Box } from "@mui/material";
import { Editor } from '@tinymce/tinymce-react';
import { useRef } from "react";

export const Step6 = ({ isMobile, state, setState }) => {
  const editorRef = useRef(null);

  return (
    <Box width="100%" justifyContent="flex-start">
      <Editor
        apiKey='ax5aqkn4b5z3hrjytu81zgicys048i9rfx27gzhb22nwmdq3'
        onInit={(evt, editor) => editorRef.current = editor}
        initialValue=""
        init={{
          height: 500,
          menubar: false,
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
          ],
          toolbar: 'undo redo | blocks | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
        }}
      />
    </Box >
  );
}